<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { SortOption } from './appTypes.js';

    export let options: SortOption[] = [];
    export let field: string = '';
    export let idPrefix: string = 'sort';

    const dispatch = createEventDispatcher();

    function onFieldChange(e: Event) {
        field = (e.target as HTMLSelectElement).value;
        dispatch('change', { field });
    }
</script>

<div class="sort-control">
    <label for="{idPrefix}-field" class="sort-label">Sort</label>
    <select id="{idPrefix}-field" class="sort-select" value={field} on:change={onFieldChange}>
        {#each options as opt (opt.value)}
            <option value={opt.value}>{opt.label}</option>
        {/each}
    </select>
</div>

<style>
    .sort-control {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
    }

    .sort-label {
        font-size: var(--text-sm);
        color: var(--grey-secondary);
    }

    .sort-select {
        padding: var(--space-2) var(--space-3);
        border: 1px solid var(--border-color);
        border-radius: var(--radius-input);
        background: var(--surface);
        color: var(--grey);
        font: inherit;
    }

    .sort-select:focus {
        outline: none;
        border-color: var(--primary);
        box-shadow: var(--focus-ring);
    }
</style>
